import IconButton from '@/global/components/Button/IconButton'
import { Popover, Typography } from '@mui/material'
import { Link } from 'global/components/Link'
import { LockIcon } from 'lucide-react'
import { useState } from 'react'

export default function IconeCadeado() {
    const [isPopoverVisivel, setPopoverVisivel] = useState(false)

    return (
        <>
            <IconButton
                name={`helpIcon_periodo_fechado`}
                onClick={() => setPopoverVisivel(!isPopoverVisivel)}
            >
                <LockIcon className="text-red-500" />
            </IconButton>

            <Popover
                open={isPopoverVisivel}
                onClose={() => setPopoverVisivel(false)}
                anchorEl={
                    document.getElementsByName('helpIcon_periodo_fechado')[0]
                }
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            overflow: 'visible',
                            mt: 2,
                            p: 2,
                            '&:before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                left: '94%',
                                width: 10,
                                height: 10,
                                backgroundColor: 'background.paper',
                                backgroundImage:
                                    'linear-gradient(rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12))',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
            >
                <Typography width={'fit-content'} maxWidth={400}>
                    Período fechado, para editar ou excluir será necessário{' '}
                    <Link href="/manutencao-ponto/fechamento-competencia">
                        reabrir a competência
                    </Link>{' '}
                    em que o registro foi lançado.
                </Typography>
            </Popover>
        </>
    )
}
